export default __webpack_public_path__ + "static/media/ser2-4.f63da9bb.jpg";